/**
 * Map designer-emitted question types to the explorer's matrix datatypes.
 *
 * Source of truth: survey-explorer/survey_variables_charting_specifications.md.
 * Both the API adapter (when deriving variables from raw response data) and
 * the SurveyExplorer (when reading the survey structure endpoint) need this
 * mapping. Keep it here, import it in both places.
 *
 * Rule: if the question type is missing or unrecognized, return
 * 'categorical-freetext-unmapped' — the safe fallback that triggers the
 * mapper banner when unique values exceed the variation threshold.
 */
const TYPE_TO_MATRIX = {
    'yes_no':   'categorical-bounded',
    'choice':   'categorical-bounded',
    'scale':    'ordinal',
    'number':   'numeric',
    'file':     'file-upload',
    'text':     'categorical-freetext-unmapped',
    'email':    'identifier',
    // system-level (added by the explorer, not from survey structure):
    'datetime': 'datetime',
    'duration': 'duration',
};

export function mapQuestionTypeToMatrixType(questionType) {
    return TYPE_TO_MATRIX[questionType] || 'categorical-freetext-unmapped';
}
